import { render, staticRenderFns } from "./PPTU.vue?vue&type=template&id=bbacd946&"
import script from "./PPTU.vue?vue&type=script&lang=js&"
export * from "./PPTU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports